import { type Moment, moment } from "@msuite/utils/date";
import type { ProtocolPriorityType } from "../types";

const FORMAT = "YYYY-MM-DDTHH:mm";

export function getProtocolPriorityCallbackTime(
	priority: ProtocolPriorityType,
	date = moment().format(FORMAT),
	subtractHours = 0,
): string {
	let currentDate = moment(date, FORMAT).startOf("hour").clone();
	switch (priority) {
		case "very-high":
			currentDate.add(1 - subtractHours, "hours");
			break;
		case "high":
			currentDate.add(2 - subtractHours, "hours");
			break;
		case "medium":
			currentDate.add(4 - subtractHours, "hours");
			break;
		case "low":
			currentDate.add(8 - subtractHours, "hours");
			break;
		case "custom":
			currentDate.startOf("hour").add(2, "hour");
			break;
	}
	if (!callbackDateIsWithinBusinessHours(currentDate)) {
		currentDate = currentDate.add(1, "days").hour(6).minute(0).second(0);
		const hoursTillClosing = getDiffHours();
		return getProtocolPriorityCallbackTime(priority, currentDate.format(FORMAT), hoursTillClosing);
	} else {
		return currentDate.format(FORMAT);
	}
}

/**
 * Determines if the given date is within the business hours.
 *
 * @param {Moment} date - The date to check.
 * @return {boolean} Returns true if the date is within the business hours, false otherwise.
 */
function callbackDateIsWithinBusinessHours(date: Moment): boolean {
	const isFriday = date.isoWeekday() === 5;
	const earliestDate = moment().setTime("06:00");
	const latestDate = moment().setTime(isFriday ? "16:30" : "17:30");
	const compareTime = date.format("HH:mm");
	const compareDate = moment().setTime(compareTime);
	const isWeekend = date.isWeekend();
	if (isWeekend) return false;
	if (compareDate.isBetween(earliestDate, latestDate)) return true;
	return false;
}

/**
 * Calculates the number of hours between the current time and the closing time.
 *
 * @return {number} The number of hours between the current time and the closing time.
 */
function getDiffHours() {
	const now = moment()
		.hour(moment().hour() + 1)
		.minute(0)
		.second(0);
	const closing = moment().setTime("17:30");
	const diff = closing.diff(now, "hours");
	return diff;
}
